
/***
 * the type value is a face classification exported from Lexocad building elements
 * TODO: the definition should not be here and have to be done somehow general
 *
 * ceiling = FLOOR, upper
 */
export enum FaceClassificationEnum {
    LOWER = "lower",
    UPPER = "upper",
    INNER = "inner",
    OUTER = "outer"
}

/***
 * TODO: the definition should not be here and have to be done somehow general
 * @type {{FLOOR: string, WALL: string, ROOF: string}}
 */
export enum BuildingElementTypeEnum {
    FLOOR = "FLOOR",
    WALL =  "WALL",
    ROOF =  "ROOF"
}

